import _ from 'lodash'
import { ScriptContent } from './find-scripts'

/**
 * 動的に JavaScript をロードする
 * @param {HTMLElement} container - script 要素の追加先
 * @param {ScriptContent[]} scripts - JavaScript の内容
 * @return {Promies<void>} - スクリプトの読み込みが終わった時に解決する Promise
 */
export default async function loadScript(container: HTMLElement, scripts: ScriptContent[]): Promise<void> {
  clearExistingScripts(container)
  await loadScriptContents(container, scripts)
  triggerLoadEvent()
}

function clearExistingScripts(container: HTMLElement): void {
  while (container.firstChild) {
    container.removeChild(container.firstChild)
  }
}

async function loadScriptContents(container: HTMLElement, scripts: ScriptContent[]): Promise<void> {
  const scriptElements = scripts.map((scriptContent) => {
    const script = document.createElement('script')
    script.async = true
    if (scriptContent.src) {
      script.src = scriptContent.src
    }
    if (scriptContent.body) {
      script.innerHTML = scriptContent.body
    }
    return script
  })
  const scriptLoaded = Promise.all(scriptElements
    .filter(s => !!s.src && !s.innerHTML)
    .map((s) => {
      return new Promise((resolve, reject) => {
        s.onload = resolve
        s.onerror = resolve
        s.onabort = resolve
      })
    }))
  scriptElements.forEach(s => container.appendChild(s))
  await scriptLoaded
}

function triggerLoadEvent(): void {
  // 手動で初期化してあげないといけないサービスは、ここで個別で初期化してあげる
  loadInstagram()
}

function loadInstagram() {
  const instgrm = window['instgrm']
  if (instgrm && instgrm.Embeds && _.isFunction(instgrm.Embeds.process)) {
    instgrm.Embeds.process()
  }
}
